var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableauImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4104 38.5286V43.0757H75.2773V46.0332H83.4104V55.0904H86.5896V46.0332H94.926V43.0757H86.5896V34H83.4104V38.5286Z",
    fill: "#7099A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.83 50.0637V56.6625H44.5195V60.803H56.83V74.2039H61.3955V60.803H73.8908V56.6625H61.3955V43.4648H56.83V50.0637Z",
    fill: "#EB912C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.419 50.0637V56.6625H96.1084V61.0063H108.419V74.2039H113.169V61.0063H125.48V56.6625H113.169V43.4648H108.419V50.0637Z",
    fill: "#59879B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.227 72.5382V79.9318H68.5303V85.4401H82.227V100.227H87.7723V85.4401H101.469V79.9318H87.7723V65.1445H82.227V72.5382Z",
    fill: "#E8762C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.504 76.2734V80.9129H114.168V84.6652H122.504V93.9257H126.663V84.6652H135V80.9129H126.663V71.6523H122.504V76.2734Z",
    fill: "#5B6591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.133 76.6784V81.1146H35V84.2569H43.133V93.1293H46.3123V84.2569L54.6486 83.9611V81.1146H46.3123V72.2422H43.133V76.6784Z",
    fill: "#7099A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.83 97.5676V104.166H44.5195V108.51H56.83V121.708H61.5804V108.51H73.8908V104.166H61.5804V90.9688H56.83V97.5676Z",
    fill: "#C72035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.419 97.5676V104.166H96.1084V108.307H108.419V121.708H113.169V108.307H125.48V104.166H113.169V90.9688H108.419V97.5676Z",
    fill: "#1F447E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0219 114.331V118.952H74.6855V122.704H83.0219V131.965H87.1808V122.704H95.5172V118.952H87.1808V109.691H83.0219V114.331Z",
    fill: "#5B6591"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(35 41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableauImg);
export default __webpack_public_path__ + "static/media/tableauImg.c253f9ceb69f925cb67da9ce146be4c7.svg";
export { ForwardRef as ReactComponent };